import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { faker } from "@faker-js/faker";
import { getAccessToken } from "./auth";
import axios from "axios";

type Params = {
  alias: string;
  comment: string;
};

async function submitAlias(params: Params) {
  const token = await getAccessToken();

  const options = {
    method: "POST",
    url: "/api/v1/aliases",
    headers: { Authorization: `Bearer ${token}` },
    data: params,
  };

  const { data } = await axios.request(options);
  return data;
}

enum RequestState {
  Edit = "EDIT",
  Submitting = "SUBMIT",
  Success = "SUCCESS",
  Error = "ERROR",
}

export default function Create() {
  const [alias, setAlias] = useState(uuidv4());
  const [comment, setComment] = useState("");
  const [formState, setFormState] = useState({
    state: RequestState.Edit,
    message: "",
  });

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
  }
  function handleRandomName() {
    const name = faker.hacker.adjective() + "." + faker.hacker.noun();
    setAlias(name.replaceAll(" ", "-"));
  }
  function handleRandomUUID() {
    setAlias(uuidv4());
  }
  function handleCreate() {
    setFormState({ ...formState, state: RequestState.Submitting, message: "" });

    async function doAsync() {
      try {
        const data = await submitAlias({
          alias,
          comment,
        });
        console.log(data);
        if (data.error)
          setFormState({
            ...formState,
            state: RequestState.Error,
            message: data.error,
          });
        else {
          setFormState({
            ...formState,
            state: RequestState.Success,
            message: `Alias email ${data.email} for ${data.user} created.`,
          });
          setAlias("");
        }
      } catch (error) {
        console.error(error);
        if (axios.isAxiosError(error)) {
          setFormState({
            ...formState,
            state: RequestState.Error,
            message: error.message,
          });
        } else {
          setFormState({
            ...formState,
            state: RequestState.Error,
            message: "Unknown error.",
          });
        }
      }
    }

    doAsync();
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit}>
        <div className="row g-3 align-items-center">
          <div className="col-auto">
            <label htmlFor="inputAlias" className="col-form-label">
              Alias
            </label>
          </div>
          <div className="col-auto">
            <input
              type="text"
              id="inputAlias"
              className="form-control"
              value={alias}
              onChange={(e) => setAlias(e.target.value)}
              disabled={formState.state === RequestState.Submitting}
            />
          </div>
          <div className="col-auto">
            <span className="form-text">@spy.red</span>
          </div>
          <div className="col-auto">
            <button
              className="btn btn-primary mb-3"
              onClick={handleRandomName}
              disabled={formState.state === RequestState.Submitting}
            >
              Random Name
            </button>
          </div>
          <div className="col-auto">
            <button
              className="btn btn-primary mb-3"
              onClick={handleRandomUUID}
              disabled={formState.state === RequestState.Submitting}
            >
              Random UUID
            </button>
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="inputComment" className="form-label">
            Comment
          </label>
          <input
            type="text"
            className="form-control"
            id="inputComment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            disabled={formState.state === RequestState.Submitting}
          />
        </div>
        {formState.state === RequestState.Success && (
          <div className="alert alert-success" role="alert">
            {formState.message === "" ? "Success" : formState.message}
          </div>
        )}
        {formState.state === RequestState.Error && (
          <div className="alert alert-danger" role="alert">
            {formState.message === "" ? "Uknown Error" : formState.message}
          </div>
        )}
        <button
          className="btn btn-primary"
          onClick={handleCreate}
          disabled={formState.state === RequestState.Submitting || alias === ""}
        >
          Create
        </button>
      </form>
    </div>
  );
}
